import * as types from './constants';

const initialState = {
  dataTable: [],
  connections: [],
  loading: false,
  message: null,
  count: 0,
  next: null,
  previous: null,
  curr_page: 1,
  errors_api: {}
};

const actions = {
  // Get Refer Connections
  [types.GET_REFERRALS_CONNECTIONS_REQUEST]: state => {
    const data = {
      ...state,
      loading: true
    };

    return { ...data };
  },

  [types.GET_REFERRALS_CONNECTIONS_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
        ...payload
    };

    return { ...data };
  },

  [types.GET_REFERRALS_CONNECTIONS_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  },

  // Operations
  [types.REFERRALS_CONNECTIONS_SET_PAGE]: (state, { payload }) => {

    const data = {
      ...state,
      curr_page: parseInt(payload) || 1
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};